import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/components/doctor-appointment/doctor-appointment.tsx");
